import React, { useMemo } from "react";
import { useNavigate } from "react-router-dom";
import Breadcrumb from "./Breadcrumb";
import "../styles/FaqPage.css";
import { Plus, Minus } from "lucide-react";

export default function FaqPage() {
  const navigate = useNavigate();

  const marianaFaqs = useMemo(
    () => [
      {
        id: "faq-mariana-1",
        q: "A Ação Inglesa de Mariana acabou?",
        a: `Não. A Ação Inglesa de Mariana continua em andamento.
O processo está avançado e segue na Justiça da Inglaterra caminhando para a Fase 2, etapa em que serão analisados os diferentes tipos de prejuízos sofridos pelos clientes e os pedidos de indenização.
Estamos no rumo certo, com uma vitória importante no mérito e com grande parte do trabalho já feito para a próxima fase.`,
      },
      {
        id: "faq-mariana-2",
        q: "O meu processo continua?",
        a: `Sim. Se você é cliente do Pogust Goodhead ("PGMBM") e não recebeu uma comunicação oficial do escritório inglês informando que sua participação foi encerrada, não é necessário tomar nenhuma medida em razão das notícias que estão circulando.
Seu processo continua sendo acompanhado pela nossa equipe com toda a atenção, assim como estamos fazendo há anos.`,
      },
      {
        id: "faq-mariana-3",
        q: "Ouvi falar sobre uma decisão do Comitê de Clientes que trocou, de forma válida, a representação dos clientes por outro escritório de advocacia. Essa informação é verdadeira?",
        a: `Não. Até o momento, não houve qualquer mudança válida na representação dos clientes perante a Justiça inglesa.
Fiquem tranquilos: o Pogust Goodhead ("PGMBM") continua sendo o escritório que representa você na Ação Inglesa.`,
      },
      {
        id: "faq-mariana-4",
        q: "O que aconteceu, então?",
        a: `O Comitê de Clientes anunciou uma decisão para tentar substituir o Pogust Goodhead ("PGMBM") por outro escritório.
Acontece que o Comitê não possui autoridade para simplesmente alterar a representação dos clientes, inclusive sem a sua consulta ou a sua autorização prévia.
Além disso, qualquer mudança de representação no processo inglês deve seguir os procedimentos aplicáveis e ser aprovado pela Justiça inglesa.
Portanto, neste momento, todos os clientes continuam sendo representados pelo Pogust Goodhead ("PGMBM") e não precisam tomar nenhuma medida.`,
      },
      {
        id: "faq-mariana-5",
        q: "O que é o Comitê de Clientes?",
        a: `O Comitê de Clientes é um grupo criado no âmbito da relação entre o Pogust Goodhead ("PGMBM") e determinados clientes para tratar de questões relacionadas à representação e aos interesses desses clientes.
É importante esclarecer que o Comitê de Clientes não é um órgão da Justiça inglesa e não representa todos os clientes da Ação Inglesa de Mariana.`,
      },
      {
        id: "faq-mariana-6",
        q: "O que o Comitê de Clientes decide sobre a representação vale automaticamente para todos os clientes?",
        a: `Não, uma decisão tomada pelo Comitê não significa automaticamente uma decisão para todos os clientes do processo, principalmente quando se trata de alterar a representação dos clientes perante à Corte Inglesa.
Qualquer mudança dessa importância deve, primeiro, ser debatida com os clientes e autorizada por eles. A sua voz precisa ser escutada.
Além disso, para que a mudança de representação dos clientes seja efetiva, é necessário que a Corte Inglesa autorize a mudança.
Esta consulta e autorização não aconteceram.
Dessa forma, o Pogust Goodhead ("PGMBM") continua representando centenas de milhares de clientes na Ação Inglesa de Mariana e entende que o Comitê não tem autoridade para encerrar ou transferir a representação de todos os clientes do processo de forma coletiva e automática.`,
      },
      {
        id: "faq-mariana-7",
        q: "A decisão do Comitê significa que preciso trocar de advogado?",
        a: `Não. A decisão do Comitê de Clientes não significa que você precise contratar outro advogado ou tomar qualquer medida em relação ao seu processo.
Se você é cliente do Pogust Goodhead ("PGMBM"), continue acompanhando nossas comunicações oficiais, utilizando nossos canais de atendimento caso tenha alguma dúvida ou converse com o seu advogado brasileiro de confiança.
Não recomendamos que você tome qualquer decisão com base apenas em informações recebidas de terceiros.`,
      },
      {
        id: "faq-mariana-8",
        q: "O que é a Fase 2?",
        a: `A Fase 2 é a próxima etapa importante do processo, que irá analisar as perdas e irá tratar das quantificações dos danos.
Depois de a Justiça inglesa ter reconhecido a responsabilidade da BHP pelo rompimento da barragem de Fundão, o processo avançará para a análise dos danos sofridos pelas pessoas atingidas e dos valores das indenizações.
O julgamento da Fase 2 está atualmente previsto para começar em abril de 2027 e estamos muito confiantes para esta nova etapa no processo.`,
      },
      {
        id: "faq-mariana-9",
        q: 'O que o Pogust Goodhead ("PGMBM") está fazendo neste momento?',
        a: `Nossa equipe já está trabalhando na preparação para a Fase 2.
Esse trabalho envolve, entre outras atividades:
análise de documentos e informações recebidas dos clientes e dos réus;
preparação das questões jurídicas e das provas necessárias para a comunicação oficial do Pogust Goodhead ("PGMBM") solicitando alguma providência.
Neste momento, é importante manter seus dados de contato atualizados para que possamos entrar em contato com você sempre que houver alguma informação ou ação necessária.`,
      },
      {
        id: "faq-mariana-10",
        q: "A ação continua sendo financiada?",
        a: `Sim. Recentemente, foram assegurados US$ 150 milhões adicionais em financiamento para apoiar o trabalho necessário para a próxima etapa do processo.
Isso permite que a preparação para a Fase 2 continue avançando.`,
      },
      {
        id: "faq-mariana-11",
        q: "Posso confiar nas informações que recebo de outras pessoas ou pela internet?",
        a: `Recomendamos que você tenha cuidado com informações compartilhadas por terceiros, especialmente quando não estiver claro de onde elas vieram.
A Ação Inglesa de Mariana é um processo muito grande e complexo, e diferentes informações e interpretações podem circular.
Por isso, considere sempre as comunicações oficiais do PGMBM como sua principal fonte de informação sobre o seu processo, seja através de nosso e-mail ou através de nossa conta oficial no Instagram.
Em caso de dúvida, entre em contato conosco antes de tomar qualquer decisão.`,
      },
      {
        id: "faq-mariana-12",
        q: "O que devo fazer se alguém entrar em contato comigo dizendo que preciso trocar de advogado?",
        a: `Não tome nenhuma decisão com pressa.
Se receber uma mensagem, ligação ou qualquer outra comunicação dizendo que você precisa trocar de advogado ou tomar alguma providência em relação ao seu processo, recomendamos que primeiro confirme essa informação diretamente com o Pogust Goodhead ("PGMBM").
Nossa equipe poderá esclarecer se a informação recebida é verdadeira e se existe alguma medida que você realmente precise tomar.`,
      },
      {
        id: "faq-mariana-13",
        q: "Quando vou receber novas informações sobre o meu processo?",
        a: `Continuaremos enviando comunicações oficiais sempre que houver informações relevantes ou alguma providência necessária por parte dos clientes.
Também estamos trabalhando para melhorar nossos canais de comunicação e facilitar o acesso dos clientes às informações sobre seus processos.`,
      },
      {
        id: "faq-mariana-14",
        q: "Qual é a informação mais importante neste momento?",
        a: `Seu processo continua. A ação continua. O trabalho continua.
A preparação para a Fase 2 está em andamento e o julgamento está atualmente previsto para abril de 2027.
O Pogust Goodhead ("PGMBM") continua representando todos os clientes e trabalhando para proteger seus interesses e para buscar a melhor solução possível para as pessoas atingidas pelo rompimento da barragem de Fundão.`,
      },
    ],
    [],
  );

  const faqs = useMemo(
    () => [
      {
        id: "faq-1",
        q: "Estou ligando para uma atualização no caso. Qual o status atual da ação?",
        a: `O caso foi ajuizado em 5 de novembro de 2018 no Tribunal Superior da Inglaterra e do País de Gales. O caso foi arquivado em 2021, mas em 8 de julho de 2022, o Tribunal de Apelação decidiu que os reclamantes têm o direito de ter suas reivindicações ouvidas na Inglaterra. Esta decisão foi tomada por um painel de três juízes do segundo tribunal superior da Inglaterra. Embora o processo ainda esteja em andamento e a demanda ainda não tenha sido resolvida, isso já é motivo de celebração. Estamos mais próximos de alcançar justiça para você e os outros clientes afetados pelo rompimento da barragem.`,
      },
      {
        id: "faq-2",
        q: "Porque a data do julgamento é só em 2024?",
        a: `Este processo tem muitas etapas até a data do julgamento em si, desde audiências menores, às apresentações de documentos e provas, por exemplo. Estamos em contato constante com nossos clientes com atualizações e informações sobre a ação, e continuaremos a fazer isso até essa data.  No entanto, o Pogust Goodhead espera que a BHP faça a coisa certa ainda em 2023, demonstrando interesse em ouvir as vítimas do desastre de Mariana. Nós sempre atuaremos nos melhores interesses de nossos clientes, e faremos de tudo para facilitar esse diálogo ainda no início do ano.`,
      },
      {
        id: "faq-3",
        q: "Eu já tenho um processo em andamento no Brasil, e/ou já recebi compensação; posso continuar na ação inglesa?",
        a: `Sim. Você não será prejudicado por estar em processos na Inglaterra e no Brasil, mas você não poderá ser indenizado duas vezes. Se você receber indenização na Inglaterra, é provável que o juiz no Brasil leve isso em consideração ao definir a indenização que você receberá. Da mesma forma, o juiz na Inglaterra poderá considerar qualquer indenização recebida no Brasil. Entretanto, a corte na Inglaterra ainda não decidiu a validade dos acordos com cláusula de quitação total/compromisso/renúncia assinados no Brasil com relação às ações ajuizadas no exterior. Se você assinou esse acordo após ter respondido seu questionário, você precisa entrar em contato com seu advogado brasileiro ou com o Pogust Goodhead imediatamente, pois a situação da sua ação na Inglaterra poderá ser afetada.`,
      },
      {
        id: "faq-4",
        q: "Posso deixar a ação inglesa?",
        a: `Você tem o direito de desistir da ação da Inglaterra a qualquer momento ou por qualquer (ou nenhuma) razão. Entretanto, se você escolher sair da ação na Inglaterra você poderá ser cobrado por quaisquer (a) custos básicos e/ou desembolsos que o Pogust Goodhead tenha realizado no processo de ajuizamento da sua ação na Inglaterra; e (b) sua parte no pagamento dos custos básicos e/ou desembolsos relacionados à ação no geral. Você só será cobrado pelo pagamento dos custos básicos e/ou desembolsos que ocorreram até a data em que você sair da ação. Além disso, a saída da ação na Inglaterra pode resultar no pagamento de custos e honorários advocatícios para a BHP. Nos termos do acordo de retenção de valores com o Pogust Goodhead, você ainda pode ser cobrado ao pagamento dessas custas. Se você decidir sair, você precisa notificar o Pogust Goodhead para que possamos encontrar a melhor solução para o seu caso específico e determinar quanto você precisaria pagar para sair da ação, se for o caso.`,
      },
      {
        id: "faq-5",
        q: "Quanto vou receber e quanto o escritório ganha?",
        a: `Ainda não é possível determinar quanto cada pessoa vai receber porque o juiz ainda vai analisar as provas e as avaliações. Como todas as demandas são diferentes, isso vai depender de cada caso individual. Estamos empenhados em garantir que você receba uma indenização justa e adequada ao dano sofrido. O Pogust Goodhead não vai cobrar nenhuma quantia adiantada para que você se torne cliente ou entre na ação da Inglaterra, de acordo com os termos do nosso contrato de retenção. O Pogust Goodhead também nunca vai recomendar ao seu advogado brasileiro que lhe cobre qualquer quantia adiantada. Qualquer pessoa, escritório de advocacia ou entidade que cobre dinheiro para assegurar a sua participação na ação não seguirá as instruções do Pogust Goodhead. O Pogust Goodhead também não cobrará nenhuma quantia de você caso a ação seja perdida. Se você vencer ou fazer acordo na sua ação na Inglaterra ou no Brasil (com a permissão do Pogust Goodhead), cobraremos no máximo 30% da soma das indenizações que você receber. Impostos poderão ser aplicados conforme a legislação brasileira.`,
      },
      {
        id: "faq-6",
        q: "Quais são as nossas chances de ganhar?",
        a: `Fomos bem-sucedidos no nosso recurso à Corte de Apelações, e as cortes inglesas confirmaram, portanto, o seu poder de julgar nossa ação. Como resultado, estamos muito confiantes nas perspectivas de obter justiça para você e para os nossos outros clientes afetados pelo rompimento da barragem do Fundão.`,
      },
      {
        id: "faq-7",
        q: "Quanto tempo vai demorar para receber a compensação?",
        a: `Você receberá a indenização em questão quando o caso for concluído – por decisão judicial ou acordo. Nós não conseguimos fornecer uma previsão neste momento; no entanto, a última decisão da Corte de Apelações foi um passo à frente para obtermos justiça, em breve, para você e os outros afetados pelo rompimento da barragem do Fundão.`,
      },
      {
        id: "faq-8",
        q: "Vou contribuir para a conclusão do acordo quando estiver completo?",
        a: `Nós só aceitaremos um acordo nos termos e instruções dadas pelos nossos clientes. Entraremos em contato em breve com informações sobre como consultaremos e manteremos você e outros clientes atualizados sobre quaisquer discussões de acordos.`,
      },
      {
        id: "faq-9",
        q: "Eu preciso demonstrar provas/evidências do dano?",
        a: `Nós só aceitaremos um acordo nos termos e instruções dadas pelos nossos clientes. Entraremos em contato em breve com informações sobre como consultaremos e manteremos você e outros clientes atualizados sobre quaisquer discussões de acordos.`,
      },
      {
        id: "faq-10",
        q: "Porque o Pogust Goodhead está propondo essa ação na Inglaterra e não no Brasil?",
        a: `O Pogust Goodhead acredita que os afetados serão devidamente indenizados dentro de um tempo razoável na Inglaterra. É possível que o Pogust Goodhead consiga a indenização na Inglaterra porque a BHP Billiton é uma emprega Anglo-Australiana com sede na Inglaterra. A BHP, junto com a Vale, é uma das empresas donas da Samarco.`,
      },
      {
        id: "faq-11",
        q: "Vou precisar ir para o tribunal na Inglaterra?",
        a: `Provavelmente não, mas os juízes Ingleses podem pedir para ouvir testemunhas brasileiras.`,
      },
      {
        id: "faq-12",
        q: "Quais documentos preciso digitalizar e enviar para o Pogust Goodhead nessa etapa do processo?",
        a: `Você deverá escanear e encaminhar para o Pogust Goodhead os seguintes documentos:
- Contrato de Honorários ad exitum assinado por você e pelo seu advogado brasileiro;
- Procuração assinada em nome do seu advogado brasileiro;
- Questionário de Perdas e Danos em formato eletrônico (preenchido e assinado);
- Cópia escaneada do seu CPF (ou qualquer documento oficial indicando o número);
- Cópia escaneada do seu documento de identidade (RG ou Certidão de Nascimento); e
- Cópia escaneada do seu comprovante de residência (uma declaração é suficiente se não houver outro tipo de prova).

Se você não escaneou e encaminhou esses documentos para o Pogust Goodhead, por favor, entre em contato com o seu advogado brasileiro imediatamente. O Pogust Goodhead não irá, em nenhum momento, reter seus documentos originais.

Se você está representando um espólio ou uma pessoa falecida, o seu advogado brasileiro entrará em contato com a lista de documentos que você precisa fornecer, caso você ainda não tenha fornecido.

Se você está representando um adulto plenamente capaz (por exemplo, um familiar), você precisará fornecer, ao seu advogado brasileiro, uma procuração assinada pela pessoa que você representa, caso ainda não tenha fornecido. Você pode solicitar uma Procuração em branco ao seu advogado brasileiro.

Se você está representando uma criança, ou um adulto incapaz, o seu advogado brasileiro entrará em contato com você para solicitar os documentos indicados abaixo, caso você ainda não tenha fornecido:
- Os documentos de identificação acima: assinados por você, quando apropriado
- Formulário de Representante (N235) preenchido e assinado (uma cópia em branco será entregue a você);
- Cópia escaneada do seu (como representante) documento de identidade (RG ou certidão de nascimento);
- Se você é o pai ou a mãe, uma cópia da certidão de nascimento do seu filho;
- Se você está atuando com a autoridade dos pais ou do guardião legal, uma cópia da procuração assinada pelos pais; e
- Em caso de adultos incapazes, a decisão judicial determinando a incapacidade e definindo o representante legal (curatela).`,
      },
    ],
    [],
  );

  return (
    <div className="main-wrapper">
      <Breadcrumb
        items={[
          { label: "Página Inicial", link: "/dashboard" },
          { label: "Perguntas frequentes" },
        ]}
      />

      <div className="faqPage">
        <section className="faqCard">
          <div className="faqHeader">
            <h1 className="faqTitle">Perguntas Frequentes</h1>
          </div>

          <div className="faqGroups">
            <details className="faqGroup" open>
              <summary className="faqGroupSummary">
                <span className="faqGroupIconWrap" aria-hidden="true">
                  <Plus className="faqGroupIcon faqGroupIconPlus" size={16} />
                  <Minus
                    className="faqGroupIcon faqGroupIconMinus"
                    size={16}
                  />
                </span>
                <span className="faqGroupTitle">
                  Atualização — Ação Inglesa de Mariana
                </span>
              </summary>

              <div className="faqGroupContent">
                <div className="faqIntro">
                  <p className="faqIntroP">
                    Sabemos que informações e comentários sobre a Ação
                    Inglesa de Mariana têm circulado recentemente e que isso
                    pode gerar dúvidas e preocupação. Por isso, reunimos
                    abaixo algumas das principais perguntas que nossos
                    clientes podem ter neste momento.
                  </p>
                </div>

                <div className="faqList">
                  {marianaFaqs.map((item) => (
                    <details key={item.id} className="faqItem">
                      <summary className="faqSummary">
                        <span className="faqIconWrap" aria-hidden="true">
                          <Plus className="faqIcon faqIconPlus" size={18} />
                          <Minus className="faqIcon faqIconMinus" size={18} />
                        </span>

                        <span className="faqQuestion">{item.q}</span>
                      </summary>

                      <div className="faqAnswer">
                        {String(item.a)
                          .split("\n")
                          .filter((line) => line !== undefined)
                          .map((line, idx) => (
                            <p key={idx} className="faqAnswerP">
                              {line.trim()}
                            </p>
                          ))}
                      </div>
                    </details>
                  ))}
                </div>

                <div className="faqClosing">
                  <h3 className="faqClosingTitle">Em caso de dúvida</h3>
                  <p className="faqClosingP">
                    Sabemos que este é um processo longo e que notícias e
                    informações diferentes podem gerar insegurança.
                  </p>
                  <p className="faqClosingP">
                    Por isso, não hesite em procurar nossos canais oficiais
                    de atendimento sempre que tiver alguma dúvida ou o seu
                    advogado brasileiro de confiança.
                  </p>
                  <p className="faqClosingP">
                    Estamos aqui para manter você informado e acompanhar seu
                    processo durante as próximas etapas.
                  </p>
                </div>
              </div>
            </details>

            <details className="faqGroup">
              <summary className="faqGroupSummary">
                <span className="faqGroupIconWrap" aria-hidden="true">
                  <Plus className="faqGroupIcon faqGroupIconPlus" size={16} />
                  <Minus
                    className="faqGroupIcon faqGroupIconMinus"
                    size={16}
                  />
                </span>
                <span className="faqGroupTitle">Perguntas Gerais</span>
              </summary>

              <div className="faqGroupContent">
                <div className="faqList">
                  {faqs.map((item) => (
                    <details key={item.id} className="faqItem">
                      <summary className="faqSummary">
                        <span className="faqIconWrap" aria-hidden="true">
                          <Plus className="faqIcon faqIconPlus" size={18} />
                          <Minus className="faqIcon faqIconMinus" size={18} />
                        </span>

                        <span className="faqQuestion">{item.q}</span>
                      </summary>

                      <div className="faqAnswer">
                        {String(item.a)
                          .split("\n")
                          .filter((line) => line !== undefined)
                          .map((line, idx) => (
                            <p key={idx} className="faqAnswerP">
                              {line.trim()}
                            </p>
                          ))}
                      </div>
                    </details>
                  ))}
                </div>
              </div>
            </details>
          </div>

          <div className="faqFooter">
            <button
              type="button"
              className="faqBackBtn"
              onClick={() => navigate(-1)}
            >
              Voltar
            </button>
          </div>
        </section>

        <div className="bottomSpacer" />
      </div>
    </div>
  );
}
